import React, { useEffect } from 'react';
import { Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useSelector, useDispatch } from 'react-redux';
import { setUserCardList } from '@/redux/actions/cardListActions';
import Label from '@/components/form/Label/Label';
import './PaymentCardSelectorView.scss';

const SearchBar = ({ languageData, onBack }) => (
  <FlexContainer className="SearchBar align-items-end">
    <i className="fa fa-chevron-left" onClick={onBack}></i>
    <Label className="fontWhite text-12 margl10" onClick={onBack}>
      {languageData === 'EN'
        ? 'Back to Reservation Details'
        : 'Volver al detalle de reservación'}
    </Label>
  </FlexContainer>
);

const CardTypeSelector = ({
  selectedCard,
  showDropdown,
  cardTypes,
  handleCardSelect,
  toggleDropdown,
  userCardList,
  selectCard,
  dropdownRef,
}) => (
  <Box position="relative" width="100%">
    {userCardList.map((card, index) => {
      const backgroundClass =
        card.isDefault || card.isSelected ? 'bgBlue400 ' : '';
      return (
        <Box
          mb={2}
          key={card.id}
          position="relative"
          onClick={() => selectCard(card.id)}
        >
          <Box className="pos-rel width100">
            <Box ref={dropdownRef}>
              <FlexContainer
                className={`${backgroundClass} align-items-center border-rad18px grayShadowBottom padt30 padr14 padb10 padl14 width100 boxSizing_borderBox border1 pos-rel`}
              >
                <Label className="fontNeutral100 text-14 width100">
                  {'**** **** **** ' + card.cardNumber?.slice(-4)}
                </Label>

                <FlexContainer
                  className="align-items-center justify-center noShrink pointer pos-rel width-40px height-28px bottom10 bgWhite"
                  style={{ transition: 'all 0.2s ease' }}
                  onClick={e => {
                    e.stopPropagation();
                    toggleDropdown(card.id);
                  }}
                >
                  {selectedCard?.icon && (
                    <img
                      src={selectedCard.icon}
                      alt={selectedCard.name}
                      className="width-35px height-16px borderrad1 objectContain"
                    />
                  )}

                  {showDropdown && (
                    <FlexContainer
                      ref={dropdownRef}
                      className="flex-column pos-abs top100 right0 borderrad6 padtb4 padlr0 margt4 overflowY"
                      style={{
                        backgroundColor: 'rgba(0,0,0,0.95)',
                        border: '1px solid rgba(255,255,255,0.3)',
                        minWidth: '80px',
                        zIndex: 1000,
                        maxHeight: '160px',
                      }}
                    >
                      {cardTypes.map(cardType => (
                        <FlexContainer
                          key={cardType.type}
                          className="align-items-center justify-center padv4 padh8 pointer"
                          style={{
                            backgroundColor:
                              selectedCard?.type === cardType.type
                                ? 'rgba(255,255,255,0.15)'
                                : 'transparent',
                          }}
                          onClick={e => {
                            e.stopPropagation();
                            handleCardSelect(cardType);
                          }}
                        >
                          <img
                            src={cardType.icon}
                            alt={cardType.name}
                            className="width-22px height-14px borderrad1 objectContain"
                          />
                        </FlexContainer>
                      ))}
                    </FlexContainer>
                  )}
                </FlexContainer>
              </FlexContainer>
            </Box>
            <label
              className="pos-abs top12 left16 text-14 pointerEventsNone"
              style={{ color: 'rgba(255,255,255,0.7)', fontWeight: 500 }}
            >
              {card.details}
            </label>
          </Box>
        </Box>
      );
    })}
  </Box>
);

const PaymentCardSelectorView = props => {
  const {
    onBack,
    languageData,
    selectedCard,
    showDropdown,
    cardTypes,
    handleCardSelect,
    toggleDropdown,
  } = props;

  const userCardList = useSelector(state => state.userCardList);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const mapPaymentMethods = data =>
    data.map(item => ({
      id: item.token,
      customerId: item.customerId,
      isDefault: item.isDefault === '1',
      card: {
        brand: 'card',
        last4: '****',
      },
      cardNumber: item.cardNumber,
      icon: item.icon,
      details: item.details,
      isSelected: item.isSelected,
    }));

  useEffect(() => {
    if (Array.isArray(cardTypes) && cardTypes.length > 0) {
      console.log('ar: ', cardTypes);
      const mapped = mapPaymentMethods(cardTypes);
      console.log('ar2: ', mapped);
      dispatch(setUserCardList(mapped));
    }
  }, [cardTypes, dispatch]);

  const selectCard = cardId => {
    const updatedUserCardList = userCardList.map(card => ({
      ...card,
      isSelected: card.id === cardId,
    }));
    dispatch(setUserCardList(updatedUserCardList));
    onBack();
  };

  const handleNewCard = () => {
    navigate(languageData === 'EN' ? '/payment-data' : '/datos-pago');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const PaymentCardSelectorForm = props => {
    const { languageData, onBack, dropdownRef } = props;
    return (
      <FlexContainer className={'flex-column margt40 margb20'}>
        <CardTypeSelector
          languageData={languageData}
          selectedCard={selectedCard}
          showDropdown={showDropdown}
          cardTypes={cardTypes}
          handleCardSelect={handleCardSelect}
          toggleDropdown={toggleDropdown}
          userCardList={userCardList}
          selectCard={selectCard}
          dropdownRef={dropdownRef}
        />
        <Button
          onClick={() => onBack()}
          className={''}
          fullWidth
          sx={{
            mt: '10px',
            py: 0.8,
            border: '2px solid rgba(255,255,255)',
            color: 'rgba(255,255,255,0.9)',
            borderRadius: '10px',
            textTransform: 'none',
            transition: 'all 0.2s ease',
            fontSize: '16px',
            '&:hover': {
              transform: 'translateY(-1px)',
            },
            '&:disabled': {
              opacity: 0.7,
            },
          }}
        >
          {languageData === 'EN' ? 'Continue' : 'Continuar'}
        </Button>
      </FlexContainer>
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  return (
    <FlexContainer className="PaymentCardSelectorView flex-column padlr10 justify-start items-center bgGradientBlue fontWhite height-950px">
      <SearchBar languageData={languageData} onBack={onBack} />
      <FlexContainer className={'flex-column padlr20 margb30'}>
        <FlexContainer className="justify-between items-center width-100 margtb10 align-items-start">
          <Label
            className="text-28 whitespace-preline lineHeight-1-1 fontWhite"
            style={{
              fontWeight: 500,
            }}
          >
            {languageData === 'EN'
              ? 'Choose your \nCard'
              : 'Elige una \nTarjeta'}
          </Label>
          <button
            className="margt22 bgGradientPurple flex-container align-items-center justify-center gap-6 bgTransparent fontWhite padtb12 padlr14 borderrad50 text-12 pointer lineHeight-1"
            onClick={handleNewCard}
            style={{
              border: '2px solid rgba(255,255,255)',
              fontWeight: 500,
              transition: 'all 0.2s ease',
            }}
            onMouseOver={e => {
              e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.8)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.6)';
            }}
          >
            <i className="fas fa-plus margt1"></i>
            {languageData === 'EN' ? 'New Card' : 'Nueva Tarjeta'}
          </button>
        </FlexContainer>
        <Label className={'text-12 margb10 whitespace-preline'}>
          {languageData === 'EN'
            ? 'Pick a card to complete your \npayment securely.'
            : 'Elige una tarjeta para \ncompletar tu pago de forma segura.'}
        </Label>
        <Label className={'text-12 margb10 whitespace-preline'}>
          {languageData === 'EN'
            ? 'For your security, only the last four digits are shown.'
            : 'Por su seguridad, solo se muestran los últimos 4 digitos de su tarjeta.'}
        </Label>
        <PaymentCardSelectorForm languageData={languageData} onBack={onBack} />
      </FlexContainer>
    </FlexContainer>
  );
};

export default PaymentCardSelectorView;
